import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Story from './components/Story';
import Features from './components/Features';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import GoogleAnalytics from './components/GoogleAnalytics';

function HomePage() {
  return (
    <>
      <main>
        <Hero />
        <Problem />
        <Story />
        <Features />
        <FAQ />
      </main>
    </>
  );
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize('G-FVJCCTC0CS');
    
    // Initialize Meta Pixel
    ReactPixel.init('796941001909422');
    ReactPixel.pageView();
    
    // Track initial page view
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <Router>
      <div className="App">
        <GoogleAnalytics />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
